var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home-wrap"},[(_vm.isClientUser)?_c('div',[(_vm.isPeraltaClient)?_c('peralta-client-home'):(_vm.isAheadClient)?_c('ahead-client-home'):_vm._e()],1):(_vm.isCoreUser)?_c('staff-home'):(_vm.isConsultantUser)?_c('consultant-home'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }